import {useMutation} from "@apollo/client";
import {Fragment, useState} from "react";
import {useDispatch} from "react-redux";
import {DeleteDeviceVariantDocument, DeleteDeviceVariantMutation} from "./queries.generated";
import {showNotification} from "../../actions";
import {defineMessage} from "react-intl";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ConfirmDialog} from "@dvrt/graphql-widgets";

type Props = {
    id: number;
    name: string;
    onSuccess?: () => void;
};
export default ({id, name, onSuccess}: Props) => {
    const [isDialogOpen, setDialogOpen] = useState(false);
    const dispatch = useDispatch();

    const [mutation] = useMutation<DeleteDeviceVariantMutation>(DeleteDeviceVariantDocument, {
        onCompleted(data) {
            if (data.deleteDeviceVariant.length) {
                dispatch(
                    showNotification(
                        defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}),
                        "error",
                    ),
                );
                return;
            }

            dispatch(
                showNotification(
                    defineMessage({id: "device_variant.deleted", defaultMessage: "Device variant deleted"}),
                    "success",
                ),
            );
            if (onSuccess) onSuccess();
        },

        onError(_error) {
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            );
        },
    });

    return (
        <Fragment>
            <IconButton color="secondary" onClick={() => setDialogOpen(true)} size="small">
                <FontAwesomeIcon icon="trash" />
            </IconButton>
            <ConfirmDialog
                isOpen={isDialogOpen}
                close={() => setDialogOpen(false)}
                onConfirm={() => mutation({variables: {id}})}
                message={defineMessage({
                    id: "confirms.delete_device_variant",
                    defaultMessage: 'Do you really want to delete "{name}"?',
                })}
                messageVars={{name}}
                buttonIdPrefix="delete-device-variant"
                warningMessage={defineMessage({
                    id: "device_variant.delete_warning",
                    defaultMessage: "Devices that use this variant switch to the default template",
                })}
            />
        </Fragment>
    );
};
